import { useLocation, useHistory } from 'react-router-dom';
import { useEffect } from 'react';

interface QueryParams {
  [key: string]: string | null;
}

const useQueryParams = (paramList: string[], clean?: boolean): QueryParams => {
  const location = useLocation();
  const history = useHistory();
  const query = new URLSearchParams(location.search);

  const params: QueryParams = {};

  paramList.forEach((param) => {
    params[param] = query.get(param);
  });

  useEffect(() => {
    if (clean && location.search) {
      history.replace({ pathname: location.pathname });
    }
  }, [location, history, clean]);

  return params;
};

export default useQueryParams;
